import { useState, useRef, useEffect } from 'react';
import type { PlaceDetail } from '../../types';
import { PlacePhotoGallery } from './PlacePhotoGallery';

interface PlaceHeaderProps {
  place: PlaceDetail;
  onNameChanged?: (newName: string) => void;
}

export function PlaceHeader({ place, onNameChanged }: PlaceHeaderProps) {
  const placePhotos = [place.PhotoURL1, place.PhotoURL2, place.PhotoURL3, place.PhotoURL4, place.PhotoURL5].filter(
    (u): u is string => !!u
  );

  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(place.PlaceName);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => { setName(place.PlaceName); }, [place.PlaceName]);
  useEffect(() => { if (editing) inputRef.current?.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    const trimmed = name.trim();
    if (trimmed && trimmed !== place.PlaceName) {
      onNameChanged?.(trimmed);
    } else {
      setName(place.PlaceName);
    }
  };

  return (
    <div>
      <PlacePhotoGallery photos={placePhotos} fallbackUrl={place.AutoImageURL} />
      <div style={{ padding: '12px 16px' }}>
        {editing ? (
          <input
            ref={inputRef}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={commit}
            onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') { setName(place.PlaceName); setEditing(false); } }}
            style={{
              margin: 0, fontSize: 20, fontWeight: 700, width: '100%',
              border: '1px solid #90caf9', borderRadius: 4, padding: '2px 6px',
              outline: 'none', boxSizing: 'border-box',
            }}
          />
        ) : (
          <h2
            onClick={() => setEditing(true)}
            title="Click to edit place name"
            style={{ margin: 0, fontSize: 20, fontWeight: 700, cursor: 'text' }}
          >
            {place.PlaceName}
          </h2>
        )}
        <p style={{ margin: '2px 0 0', color: '#757575', fontSize: 13 }}>
          {place.Country}
        </p>
        {place.WikiSummary && (
          <p
            style={{
              margin: '10px 0 0',
              fontSize: 13,
              lineHeight: 1.5,
              color: '#424242',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {place.WikiSummary}
          </p>
        )}
      </div>
    </div>
  );
}
